// @ts-strict-ignore
import type { Module } from 'vuex'

import type { InstanceManagementState } from '../../models'

import { ResetAction } from '../common/actions/reset.action'
import { COMMON_CONSTS } from '../common/common.consts'
import { ResetMutation } from '../common/mutations/reset.mutation'

import { ListServiceConfigsAction } from './actions/list-service-configs.action'
import { ReadSearchServiceConfigAction } from './actions/read-search-service-config.action'
import { RequestNewInstanceAction } from './actions/request-new-instance.action'
import { SetEnabledServiceConfigAction } from './actions/set-enabled-service-config.action'
import { UpdateSearchServiceConfigAction } from './actions/update-search-service-config.action'
import { UpdateServiceConfigAction } from './actions/update-service-config.action'
import { SearchServiceConfigGetter } from './getters/search-service-config.getter'
import { ServicesConfigGetter } from './getters/services-config.getter'
import { INSTANCE_MANAGEMENT_CONSTS } from './instance-management.consts'
import { SetSearchServiceConfigMutation } from './mutations/set-search-service-config.mutation'
import { SetServiceConfigsMutation } from './mutations/set-service-configs.mutation'
import { UpdateServiceConfigMutation } from './mutations/update-service-config.mutation'

export const INSTANCE_MANAGEMENT_MODULE: Module<InstanceManagementState, any> = {
  namespaced: true,

  initialState: (): InstanceManagementState => ({
    serviceConfigs: [],
    searchServiceConfig: undefined,
  }),
  state: (): InstanceManagementState => INSTANCE_MANAGEMENT_MODULE.initialState(),

  getters: {
    [INSTANCE_MANAGEMENT_CONSTS.getters.serviceConfigs]: ServicesConfigGetter.execute,
    [INSTANCE_MANAGEMENT_CONSTS.getters.searchServiceConfig]: SearchServiceConfigGetter.execute,
  },

  actions: {
    [INSTANCE_MANAGEMENT_CONSTS.actions.requestNewInstance]: RequestNewInstanceAction.execute,

    [INSTANCE_MANAGEMENT_CONSTS.actions.listServiceConfigs]: ListServiceConfigsAction.execute,
    [INSTANCE_MANAGEMENT_CONSTS.actions.readSearchServiceConfig]:
      ReadSearchServiceConfigAction.execute,
    [INSTANCE_MANAGEMENT_CONSTS.actions.updateServiceConfig]: UpdateServiceConfigAction.execute,
    [INSTANCE_MANAGEMENT_CONSTS.actions.updateSearchServiceConfig]:
      UpdateSearchServiceConfigAction.execute,
    [INSTANCE_MANAGEMENT_CONSTS.actions.setEnabledServiceConfig]:
      SetEnabledServiceConfigAction.execute,

    [COMMON_CONSTS.actions.reset]: context =>
      ResetAction.execute(context, INSTANCE_MANAGEMENT_MODULE.initialState()),
  },

  mutations: {
    [INSTANCE_MANAGEMENT_CONSTS.mutations.setServiceConfigs]: SetServiceConfigsMutation.execute,
    [INSTANCE_MANAGEMENT_CONSTS.mutations.setSearchServiceConfig]:
      SetSearchServiceConfigMutation.execute,
    [INSTANCE_MANAGEMENT_CONSTS.mutations.updateServiceConfig]: UpdateServiceConfigMutation.execute,

    [COMMON_CONSTS.mutations.reset]: ResetMutation.execute,
  },
}
